export default __webpack_public_path__ + "assets/truck-scene-bg.b717b118513a1f33c98e14890c560ad4.jpg";